// Core
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { FaTelegramPlane } from 'react-icons/fa';
import { useQuery } from 'react-query';

// Assets
import { apiService } from 'services/ApiService';
import { formatDateTime, validateLoadMore } from 'services/Utils';
import placeholderUser from 'assets/img/placeholder-user.png';
import { textLang } from 'services/Lang';

// Components
import { messages, likeMe } from '../../variables/data';

const Messages = (props) => {
	const styleText = {
	  maxWidth: '100%', 
	  whiteSpace: 'nowrap', 
	  overflow: 'hidden', 
	  textOverflow: 'ellipsis'
	};

  const [people, setPeople] = useState([]);
  const [metaPeople, setMetaPeople] = useState([]);

  const { refetch, isFetching } = useQuery({
    queryKey: ['data-liked-me'],
    queryFn: async () => {
      const params = {
        offset: 0,
        limit: 1
      };

      const response = await apiService.getLikedMe(params);
      setPeople(response.data);
      setMetaPeople(response.meta);
      
      return true;
    },
    refetchOnWindowFocus: false,
    retry: false,
	});

  const limit = 24;
  const [offset, setOffset] = useState(0);
	const [matches, setMatches] = useState([]);
  const [metaMatches, setMetaMatches] = useState([]);

  const { refetch: refetchMatches, isFetching: isFetchingMatches, isLoading } = useQuery({
    queryKey: ['data-matches', offset],
    queryFn: async () => {
      const params = {
        offset,
        limit
      };

      const response = await apiService.getMatches(params);

      if(offset === 0){
          setMatches(response.data);
        } else {
          setMatches([...matches, ...response.data]);
        }
        setMetaMatches(response.meta);

      return true;
    },
    refetchOnWindowFocus: false,
    retry: false,
	});

	const loadMore = async () => {
      setOffset(offset + limit);
  };

	return (
		<Box p="100px 15px 130px 15px" maxH="calc(100vh - 0px)" overflowY="auto" position="relative">
        <Box align='left' mt='18px'>
		<Box>
			<Text variant="title-lg" 
	          fontWeight="800"
	          textTransform="uppercase"
	          fontSize="24px">{textLang('massage_liked_me_header')}</Text>
	        <Flex w="100%" gap="16px" alignItems="center">
		        <Flex w="100%" overflow="hidden" gap="16px" my="16px" justifyContent="center">
		        	{ !isFetching && people?.length > 0 && people?.map((item, index) => (
			            <Box key={index} borderRadius="full" w="64px" h="64px" position="relative"
			            	_before={{
			            		content: '""',
			            		position: 'absolute',
			            		w: '100%',
			            		h: '100%',
			            		bg: '#ffffffad',
	    						backdropFilter: 'blur(3px)'
			            	}}>
		            		<Image 
		            			src={item?.image || placeholderUser} 
		            			w="100%" h="100%"
		            			objectFit="cover" 
		            			/>
	            		</Box>
			        ))}

			        { isFetching && <Text>{textLang('loading')}</Text>}

			        { !isFetching && people?.length === 0 && <Text>{textLang('massage_liked_me_text')}</Text>}

			        { metaPeople?.total > 1 && 
				        <Box borderRadius="full" w="64px" h="64px" bg="#e7e7e7" ml="-27px" textAlign="center" pt="20px">
				        	<Text variant="title-lg">+{metaPeople?.total - 1}</Text>
				        </Box>
				    }
		        </Flex>

		        { !isFetching && people?.length === 0 ? <></> :
			        isFetching ? <></> : 
			        	<Button as={NavLink} to="/liked-me" variant="solid-lg">{textLang('massage_liked_me_btn')}</Button>
			    }
		    </Flex>

			<Text variant="title-lg" 
	          fontWeight="800"
	          mt="8px"
	          textTransform="uppercase"
	          fontSize="32px">{textLang('massage_soulmates_header')}</Text>
	        <Box mt="16px">
	        { matches?.length > 0 && matches?.map((item, index) => (
	            <Flex key={index} 
	            	as={Link} 
	            	to={`/messages/${item?.id}`} 
	            	justifyContent="space-between" 
	            	mb="16px" 
	            	pr="24px"
	            	w="100%"
	            	alignItems="center">
	            	<Flex gap="16px" alignItems="center" w="100%">
	            		<Box borderRadius="full" maxWidth="81px" h="81px" w="100%" >
		            		<Image 
		            			src={
		            			props?.object?.id === item?.owner ? item?.userMatched?.image : item?.user?.image
		            			|| placeholderUser} 
		            			w="100%" h="100%"
		            			objectFit="cover" 
		            			/>
	            		</Box>

	            		<Box>
	            			<Text variant="title-lg">{props?.object?.id === item?.owner ? item?.userMatched?.firstName : item?.user?.firstName}</Text>
	            			{ item?.message?.owner !== props?.object?.id && item?.message?.viewed === false ? 
	            				<Flex gap="4px" alignItems="center">
	            					<Box w="100%" h="9px" maxW="9px" borderRadius="full" bg="rgb(255, 65, 51)" />
	            					<Text variant="title-sm" color="#2a2a2a" style={styleText}>{item?.message?.text}</Text>	
	            				</Flex>
	            			: <Text variant="title-sm" color="#8e8e8e" style={styleText}>{
	            				item?.message ? 
	            					props?.object?.id === item?.message?.owner ? textLang('you') + ': ' + item?.message?.text  : item?.message?.text 
	            				: textLang('empty_chat')}</Text>}
	            		</Box>
	            	</Flex>
	            </Flex>
	        ))}

	        { validateLoadMore(people, metaMatches) && (
                <Button 
                    isLoading={isLoading} 
                    variant="solid-lg" 
                    maxW="220px" 
                    onClick={loadMore} 
                    left="50%"
                    transform="translate(-50%, 0)"
                    m="24px auto">
                  {textLang('load_more')}
                </Button>
            )}

	        { !isFetchingMatches && matches?.length === 0 && 
	        	<Text>
        			{textLang('massage_soulmates_text')}
	        	</Text>
	        }
	        </Box>
		</Box>
				</Box>
		</Box>
	);
};

export default Messages;